var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 25.5H13.5C14.8978 25.5 15.5967 25.5 16.1481 25.7284C16.8831 26.0328 17.4672 26.6169 17.7716 27.3519C18 27.9033 18 28.6022 18 30V12C18 9.17157 18 7.75736 17.1213 6.87868C16.2426 6 14.8284 6 12 6H6.5C5.55719 6 5.08579 6 4.79289 6.29289C4.5 6.58579 4.5 7.05719 4.5 8V23.5C4.5 24.4428 4.5 24.9142 4.79289 25.2071C5.08579 25.5 5.55719 25.5 6.5 25.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 25.5H22.5C21.1022 25.5 20.4033 25.5 19.8519 25.7284C19.1169 26.0328 18.5328 26.6169 18.2284 27.3519C18 27.9033 18 28.6022 18 30V12C18 9.17157 18 7.75736 18.8787 6.87868C19.7574 6 21.1716 6 24 6H29.5C30.4428 6 30.9142 6 31.2071 6.29289C31.5 6.58579 31.5 7.05719 31.5 8V23.5C31.5 24.4428 31.5 24.9142 31.2071 25.2071C30.9142 25.5 30.4428 25.5 29.5 25.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpened);
export default __webpack_public_path__ + "static/media/book-opened.54a440f4c93964b837d325128ac28dbe.svg";
export { ForwardRef as ReactComponent };